<template>
  <div class="TagList">
    <XTable
        :api="getTagValueList"
        :state="tagList"
        :columns="columns"
        :loading="isBack"
        :tableSize="tableSize"
        :layout="layout"
        :firstColumn="firstColumn"
        :maxHeight="maxHeight"
    ></XTable>
  </div>
</template>

<script>
import XTable from "@/components/XTable/index.vue";
import {mapActions, mapState} from "vuex";
import DateUtil from "@/utils/formatDate";

export default {
  name: "TagList",
  components: {XTable},
  props: {
    maxHeight: {
      type: Number,
      default() {
        return null;
      },
    },
  },
  data() {
    return {
      tableSize: "small",
      layout: "sizes, prev, pager, next",
      firstColumn: true,
      back: false,
      isShow: false,
      updateCount: 0,
    };
  },
  computed: {
    ...mapState("teachingCenter", ["tagList", "tagListLoading", "isBack"]),
    ...mapState("user", ["permissionCode"]),
    columns: function () {
      const self = this;
      const columns = [
        {
          prop: "name",
          label: "标签名称",
        },
        {
          prop: "tagCategoryName",
          label: "标签分类",
        },
        {
          label: "新增日期",
          render(h, scope) {
            return (
                <div>
                  <span>{self.formatDate(scope.row.createTime)}</span>
                </div>
            );
          },
        },
      ];
      if (this.permissionCode.has('research:tag:manager')) {
        columns.push({
          label: "操作",
          fixed: "right",
          width: 300,
          render(h, scope) {
            return (
                <div>
                  <el-button
                      onClick={() => {
                        self.handleEdit(scope.row);
                      }}
                      size="mini"
                      type="primary"
                      plain
                  >
                    编辑
                  </el-button>
                  <el-button
                      onClick={() => {
                        self.handleDelete(scope.row);
                      }}
                      size="mini"
                      type="danger"
                      plain
                  >
                    删除
                  </el-button>
                </div>
            );
          },
        })
      }
      return columns;
    },
  },
  methods: {
    ...mapActions("teachingCenter", ["getTagValueList", "deleteTagValue"]),
    handleEdit(row) {
      localStorage.setItem("tagValueDetails", JSON.stringify(row));
      this.$router.push(
          {
            name: "AddTag",
            params: {
              type: "edit",
            },
          },
          () => {
          }
      );
    },
    handleDelete(row) {
      this.$confirm("请确认是否要删除该标签?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(async () => {
            try {
              await this.deleteTagValue({
                id: row.id,
              });
              await this.getTagValueList({
                page: this.tagList.page,
                size: this.tagList.size,
              });
              this.$message.success("删除成功");
            } catch (e) {
              // console.log(e);
            }
          })
          .catch(() => {
          });
    },
    //   根据时间戳计算上传时间
    formatDate(timestamp) {
      return DateUtil.formatDateFromTimestamp(timestamp);
    },
  },
};
</script>

<style lang="scss" scoped>
.TagList {
}
</style>
